import React from 'react';
import classNames from 'classnames';

export interface DropdownButtonItem {
  title: string;
  value: any;
}

interface DropdownButtonProps extends React.PropsWithChildren {
  open: boolean;
  items: DropdownButtonItem[];
  onClick: (item: DropdownButtonItem) => void;
}

export default function DropdownButton({
  children, open, items, onClick,
}: DropdownButtonProps) {
  const handleClick = (item: DropdownButtonItem) => () => {
    onClick(item);
  };

  return (
    <div className={classNames('dropdown-button', { active: open })}>
      {children}
      <div className="dropdown-button-menu">
        {
          items.map((item) => (
            <button key={item.title} type="button" onClick={handleClick(item)}>
              {item.title}
            </button>
          ))
        }
      </div>
    </div>
  );
}
